<template>
  <v-container fluid ma-0 pa-0>
    <v-row>
        <v-col cols="6" class="pa-0 d-flex align-center justify-center" style="background-color: #f1f4f6">
          <div style="width: 406px">
            <v-img src="https://east-e.co.jp/common/img/f-logo.svg" width="200px" eager style="margin: auto"></v-img>
            <h2 class="pt-4 pb-4" style="text-align:center;">ドローンレポートシステム</h2>
            <v-divider class="mb-10"></v-divider>
            <h3 class="text-center">アカウント設定</h3>
            <v-form
                ref="confirmAccountForm"
                v-model="confirmAccountValid"
            >
                <v-col cols="12" style="padding: 6px 0px;">
                    <v-text-field
                        label="名字 *"
                        type="text"
                        required
                        outlined
                        dense
                        :rules="lastNameRules"
                        v-model="inputConfirmAccount.last_name"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" style="padding: 6px 0px;">
                    <v-text-field
                        label="名前*"
                        type="text"
                        required
                        outlined
                        dense
                        :rules="nameRules"
                        v-model="inputConfirmAccount.first_name"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" style="padding: 6px 0px;">
                    <v-text-field
                        label="パスワード *"
                        :type="showPassword ? 'text' : 'password'"
                        required
                        outlined
                        dense
                        :rules="passRules"
                        v-model="inputConfirmAccount.new_password1"
                        hide-details="auto"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                        counter
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="12" style="padding:6px 0px;">
                    <v-text-field
                        label="パスワード 確認*"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        required
                        outlined
                        dense
                        :rules="passConfirmRules"
                        v-model="inputConfirmAccount.new_password2"
                        hide-details="auto"
                        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showConfirmPassword = !showConfirmPassword"
                        counter
                        clearable
                    ></v-text-field>
                </v-col>
            </v-form>
            <div v-for="(error, idx) in inputError" :key="idx">
                <span class="text-caption red--text">{{error}}</span>
            </div>
            <v-btn class="mt-4" color="primary" style="width:100%;" @click="confirm_account_mail()">OK</v-btn>
          </div>
        </v-col>
        <v-col cols="6" class="pa-0">
          <v-img src="../assets/images/cover.jpg" height="calc(100vh)" class="grey lighten-2"></v-img> 
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {store} from '../store';
export default {
    name: "ConfirmAccount",
  
    data() {
        return {
            inputConfirmAccount: {
                new_password1: null,
                new_password2:null,
                last_name: null,
                first_name: null,
                token: this.$route.params.token,
                uid: this.$route.params.uid,
            },
            confirmAccountValid: true,
            passRules: [
                v => !!v || 'パスワードを入力してください。',
                v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードを入 力してください。'
            ],
            nameRules: [
                v => !!v || '名前を入力してください。',
            ],
            lastNameRules: [
                v => !!v || '名字を入力してください。',
            ],
            passConfirmRules: [
                v => !!v || 'パスワード確認を入力してください。',
                v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードを入 力してください。'
            ],
            inputError: [],
            showPassword: false,
            showConfirmPassword: false
        }
    
    },

    methods: {
        confirm_account_mail() {
            if (this.$refs.confirmAccountForm.validate()) {
                this.axios.post("/api/account/confirm/"+this.$route.params.uid+ "/"+this.$route.params.token+"/", this.inputConfirmAccount)
                .then(() => {
                    store.showSuccessDialog("アカウントが登録されました。");
                    const loggedIn = localStorage.getItem('drs_user');
                    if (loggedIn) {
                        store.updateLogoutStatus();
                        this.axios.defaults.headers.common["Authorization"] = "";
                    }
                    this.$router.push('/login');
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        if ('password_mismatch' in error.response.data) {
                            this.inputError.push('確認用パスワードが一致しません。');
                        }
                        if ('new_password2' in error.response.data) {
                            this.inputError = error.response.data.new_password2;
                            // store.showErrorDialog(error.response.data.new_password2[0]);
                        }
                        if ('token' in error.response.data) {
                            store.showErrorDialog("登録用 URLの期限が切れました。");
                        }
                    } else {
                        store.showErrorDialog("エラーが発生しました。再度試してください。");
                    }
                });
            }
        }
    
    },

}
</script>

<style scoped>
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
>>>.v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0px;
}
</style>
